import { render, staticRenderFns } from "./AdjustProductStockPopUp.vue?vue&type=template&id=8485e136&scoped=true&"
import script from "./AdjustProductStockPopUp.vue?vue&type=script&lang=js&"
export * from "./AdjustProductStockPopUp.vue?vue&type=script&lang=js&"
import style0 from "./AdjustProductStockPopUp.vue?vue&type=style&index=0&id=8485e136&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8485e136",
  null
  
)

export default component.exports